import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import ProgramType from '../../../../components/modules/marketing/program-type';
import ProgramTypeMiddleware from '../../../../middleware/modules/marketing/program-type';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,programType }) => ({
  isProcessing: programType.isProcessing,
  isError: programType.isError,
  errorMessage: programType.errorMessage,
  datalist:programType.data,
  showModal:programType.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>ProgramTypeMiddleware.create(),
    reset: () =>ProgramTypeMiddleware.resetList(),
    search: data =>ProgramTypeMiddleware.list(data),
    update: data =>ProgramTypeMiddleware.update(data),
    delete: (id,search) =>ProgramTypeMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class ProgramTypeContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
   this.props.search(search);
  
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    
    this.props.update(id)
  }
  createItem(){
    this.props.create()
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Program Type List")}
          </title>
        </Helmet>
      <ProgramType
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramTypeContainer);
